import { Component } from '@angular/core';

@Component({
  selector: 'mcp-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
})
export class NoAccessComponent {
  private readonly imagePath: string = '/assets/images';

  get noAccessImagePath(): string {
    return `${this.imagePath}/no-access.svg`;
  }
}
